export const ALL_CLINICIANS = 1;
export const DOCTORS = 2;

export const doctorTypes = ['-', "Clinician", "GP"];